<script lang="ts">
    import cn from 'classnames';

    import { portal } from '@components/actions/portal';
    import { IconName, SvgIcon } from '@uikit/svg-icon';

    import s from './container.module.css';

    export let classes = '';
    export let contentClasses = '';
    export let backdropClasses = '';
    export let closeButtonClasses = '';
    export let closeByOutsideClick = true;
    export let isDisplayCloseIcon = true;
    export let testId: string | undefined = undefined;
    export let isHaveCloseBtn = true;

    export let closeHandler: () => void = () => isVisible = false;

    let isVisible = true;
</script>

{#if isVisible}
    <div use:portal class={cn(s.root, classes)}>
        <div
            class={cn(s.backdrop, backdropClasses)}
            data-testid="backdrop"
            on:click={closeByOutsideClick ? closeHandler : null}
        />
        <div class={cn(s.content, contentClasses)} data-testid={testId}>
            {#if isHaveCloseBtn !== false && isDisplayCloseIcon}
                <button
                    class={cn(s.close, closeButtonClasses)}
                    on:click={closeHandler}
                    data-testid="closeButton">
                    <SvgIcon icon={IconName.Close} />
                </button>
            {/if}
            <slot />
        </div>
    </div>
{/if}
